import { render, staticRenderFns } from "./Alarma.vue?vue&type=template&id=9fdc796c&scoped=true&"
import script from "./Alarma.vue?vue&type=script&lang=js&"
export * from "./Alarma.vue?vue&type=script&lang=js&"
import style0 from "./Alarma.vue?vue&type=style&index=0&id=9fdc796c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fdc796c",
  null
  
)

export default component.exports